import React, { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../assets/icons";
import Loader from "../Loader";
import { useNotification } from "../../toster-notification/NotificationContext";
import { userService } from "../../../services/userService";
import { UserModalInfoDTO } from "../../../models/user/user.response";
import UserReportView from "../UserReportView";


interface UserInfoViewProps {
    reservationId?: string;
    orderId?: string;
    id: string;
    onClose: () => void;
}

const UserInfoView: React.FC<UserInfoViewProps> = ({ id, reservationId, orderId, onClose }) => {

    const [isUserReportViewOpen, setIsUserReportViewOpen] = useState<boolean>(false);

    const [userInfo, setUserInfo] = useState<UserModalInfoDTO>();

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchUserInfo();
    }, [id])


    const fetchUserInfo = async () => {
        setLoading(true);
        try {
            const respose = await userService.getUserModalInfo(id);

            if (respose.data && respose.success) {
                setUserInfo(respose.data)
            } else {
                notify("error", "Greška prilikom dobavljanja podataka");
            }
        } catch (error: any) {
            notify("error", "Greška prilikom dobavljanja podataka");
        } finally {
            setLoading(false)
        }
    }

    if (loading) {
        <Loader />
    }

    return (
        <>

            {isUserReportViewOpen &&
                <UserReportView
                    reservationId={reservationId}
                    orderId={orderId}
                    id={id}
                    onClose={() => setIsUserReportViewOpen(false)}
                />}

            {loading ?
                (
                    <Loader />
                ) : (
                    <section className="modal-section user-info">
                        <div className="w-layout-blockcontainer container w-container">
                            <div className="modal-wrapper">
                                <div className="modal-div">
                                    <div className="modal-header-div">
                                        <div>
                                            <div className="modal-header">Profil Korisnika</div>
                                            <div className="description-text">
                                                Detalji o odabranom korisniku<br />
                                            </div>
                                        </div>
                                        <div className="modal-button-div" onClick={() => onClose()}>
                                            <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                                        </div>
                                    </div>
                                    <div className="modal-profile-image-div">
                                        <img src={userInfo?.imageUrl + "@lg.webp"} loading="lazy" sizes="(max-width: 767px) 100vw, (max-width: 991px) 95vw, 751px" alt="" className="modal-profile-image" />
                                    </div>
                                    <div className="modal-div-body grey-bg reservation">
                                        <div className="modal-div-body-header">
                                            <div className="modal-div-body-header-text description-text">
                                                Podaci o korisniku<br />
                                            </div>
                                        </div>
                                        <div className="div-block-39 user-modal">
                                            <div>
                                                <div className="description-text">Ime i prezime</div>
                                                <div className="fs-1-125rem">{userInfo?.fullName}</div>
                                            </div>
                                            <div>
                                                <div className="description-text">Telefon</div>
                                                <div className="fs-1-125rem">{userInfo?.phoneNumber}</div>
                                            </div>
                                        </div>
                                        <div className="div-block-39 user-modal">
                                            <div>
                                                <div className="description-text">Email</div>
                                                <div className="fs-1-125rem">{userInfo?.email}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-buttons one-button">
                                        <div className="button-primary medium report" onClick={() => setIsUserReportViewOpen(true)}>
                                            <div>Prijavi korisnika</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
        </>
    )
};

export default UserInfoView;